module.exports = __webpack_public_path__ + "static/media/onboarding-person-1.09bae021.jpg";